import type { DefaultTranslationsObject, Language } from '../types.js'

export const bnBdTranslations: DefaultTranslationsObject = {
  authentication: {
    account: 'অ্যাকাউন্ট',
    accountOfCurrentUser: 'বর্তমান ব্যবহারকারীর অ্যাকাউন্ট',
    accountVerified: 'অ্যাকাউন্ট সফলভাবে যাচাই করা হয়েছে।',
    alreadyActivated: 'ইতিমধ্যে সক্রিয়',
    alreadyLoggedIn: 'ইতিমধ্যে লগইন করা আছে',
    apiKey: 'এপিআই কী',
    authenticated: 'প্রমাণিত',
    backToLogin: 'লগইনে ফিরে যান',
    beginCreateFirstUser: 'শুরু করতে, আপনার প্রথম ব্যবহারকারী তৈরি করুন।',
    changePassword: 'পাসওয়ার্ড পরিবর্তন করুন',
    checkYourEmailForPasswordReset:
      'ইমেইল ঠিকানা যদি কোনো অ্যাকাউন্টের সাথে যুক্ত থাকে, তাহলে আপনি শীঘ্রই পাসওয়ার্ড রিসেট করার নির্দেশনা পাবেন। আপনার ইনবক্সে ইমেইল না দেখলে স্প্যাম বা জাঙ্ক মেইল ফোল্ডার চেক করুন।',
    confirmGeneration: 'জেনারেশন নিশ্চিত করুন',
    confirmPassword: 'পাসওয়ার্ড নিশ্চিত করুন',
    createFirstUser: 'প্রথম ব্যবহারকারী তৈরি করুন',
    emailNotValid: 'প্রদত্ত ইমেইলটি বৈধ নয়',
    emailOrUsername: 'ইমেইল বা ব্যবহারকারীর নাম',
    emailSent: 'ইমেইল পাঠানো হয়েছে',
    emailVerified: 'ইমেইল সফলভাবে যাচাই করা হয়েছে।',
    enableAPIKey: 'এপিআই কী সক্ষম করুন',
    failedToUnlock: 'আনলক করতে ব্যর্থ হয়েছে',
    forceUnlock: 'জোরপূর্বক আনলক করুন',
    forgotPassword: 'পাসওয়ার্ড ভুলে গেছেন',
    forgotPasswordEmailInstructions:
      'নিচে আপনার ইমেইল ঠিকানা লিখুন। আপনি পাসওয়ার্ড রিসেট করার নির্দেশনা সহ একটি ইমেইল বার্তা পাবেন।',
    forgotPasswordQuestion: 'পাসওয়ার্ড ভুলে গেছেন?',
    forgotPasswordUsernameInstructions:
      'নিচে আপনার ব্যবহারকারীর নাম লিখুন। আপনার ব্যবহারকারীর নামের সাথে যুক্ত ইমেইল ঠিকানায় পাসওয়ার্ড রিসেট করার নির্দেশনা পাঠানো হবে।',
    generate: 'জেনারেট করুন',
    generateNewAPIKey: 'নতুন এপিআই কী জেনারেট করুন',
    generatingNewAPIKeyWillInvalidate:
      'একটি নতুন এপিআই কী জেনারেট করলে পূর্ববর্তী কী <1>অবৈধ</1> হয়ে যাবে। আপনি কি অবশ্যই চালিয়ে যেতে চান?',
    lockUntil: 'আনলক না হওয়া পর্যন্ত',
    logBackIn: 'আবার লগইন করুন',
    loggedIn: 'অন্য ব্যবহারকারীর সাথে লগইন করতে, আপনাকে প্রথমে <0>লগআউট</0> করতে হবে।',
    loggedInChangePassword:
      'আপনার পাসওয়ার্ড পরিবর্তন করতে, আপনার <0>অ্যাকাউন্ট</0> এ যান এবং সেখানে আপনার পাসওয়ার্ড সম্পাদনা করুন।',
    loggedOutInactivity: 'নিষ্ক্রিয়তার কারণে আপনাকে লগআউট করা হয়েছে।',
    loggedOutSuccessfully: 'আপনি সফলভাবে লগআউট করেছেন।',
    loggingOut: 'লগআউট হচ্ছে...',
    login: 'লগইন',
    loginAttempts: 'লগইন প্রচেষ্টা',
    loginUser: 'ব্যবহারকারী লগইন করুন',
    loginWithAnotherUser: 'অন্য ব্যবহারকারীর সাথে লগইন করতে, আপনাকে প্রথমে <0>লগআউট</0> করতে হবে।',
    logOut: 'লগআউট',
    logout: 'লগআউট',
    logoutSuccessful: 'লগআউট সফল হয়েছে।',
    logoutUser: 'ব্যবহারকারী লগআউট করুন',
    newAccountCreated:
      'আপনার জন্য একটি নতুন অ্যাকাউন্ট তৈরি করা হয়েছে <a href="{{serverURL}}">{{serverURL}}</a> এ অ্যাক্সেস করতে। আপনার ইমেইল যাচাই করতে নিচের লিঙ্কে ক্লিক করুন বা ব্রাউজারে URL টি পেস্ট করুন: <a href="{{verificationURL}}">{{verificationURL}}</a><br> আপনার ইমেইল যাচাই করার পরে, আপনি সফলভাবে লগইন করতে পারবেন।',
    newAPIKeyGenerated: 'নতুন এপিআই কী জেনারেট করা হয়েছে।',
    newPassword: 'নতুন পাসওয়ার্ড',
    passed: 'প্রমাণীকরণ সফল হয়েছে',
    passwordResetSuccessfully: 'পাসওয়ার্ড সফলভাবে রিসেট করা হয়েছে।',
    resetPassword: 'পাসওয়ার্ড রিসেট করুন',
    resetPasswordExpiration: 'পাসওয়ার্ড রিসেটের মেয়াদ শেষ',
    resetPasswordToken: 'পাসওয়ার্ড রিসেট টোকেন',
    resetYourPassword: 'আপনার পাসওয়ার্ড রিসেট করুন',
    stayLoggedIn: 'লগইন অবস্থায় থাকুন',
    successfullyRegisteredFirstUser: 'প্রথম ব্যবহারকারী সফলভাবে নিবন্ধিত হয়েছে।',
    successfullyUnlocked: 'সফলভাবে আনলক করা হয়েছে',
    tokenRefreshSuccessful: 'টোকেন রিফ্রেশ সফল হয়েছে।',
    unableToVerify: 'যাচাই করতে অক্ষম',
    username: 'ব্যবহারকারীর নাম',
    usernameNotValid: 'প্রদত্ত ব্যবহারকারীর নামটি বৈধ নয়',
    verified: 'যাচাইকৃত',
    verifiedSuccessfully: 'সফলভাবে যাচাই করা হয়েছে',
    verify: 'যাচাই করুন',
    verifyUser: 'ব্যবহারকারী যাচাই করুন',
    verifyYourEmail: 'আপনার ইমেইল যাচাই করুন',
    youAreInactive:
      'আপনি কিছুক্ষণ ধরে সক্রিয় নেই এবং আপনার নিরাপত্তার জন্য শীঘ্রই স্বয়ংক্রিয়ভাবে লগআউট করা হবে। আপনি কি লগইন অবস্থায় থাকতে চান?',
    youAreReceivingResetPassword:
      'আপনি এটি পাচ্ছেন কারণ আপনি (বা অন্য কেউ) আপনার অ্যাকাউন্টের পাসওয়ার্ড রিসেট করার অনুরোধ করেছেন। প্রক্রিয়াটি সম্পূর্ণ করতে নিচের লিঙ্কে ক্লিক করুন, বা এটি আপনার ব্রাউজারে পেস্ট করুন:',
    youDidNotRequestPassword:
      'আপনি যদি এটি অনুরোধ না করে থাকেন, তাহলে এই ইমেইলটি উপেক্ষা করুন এবং আপনার পাসওয়ার্ড অপরিবর্তিত থাকবে।',
  },
  dashboard: {
    addWidget: 'উইজেট যোগ করুন',
    deleteWidget: 'উইজেট মুছে ফেলুন {{id}}',
    searchWidgets: 'উইজেটগুলি অনুসন্ধান করুন...',
  },
  error: {
    accountAlreadyActivated: 'এই অ্যাকাউন্ট ইতিমধ্যে সক্রিয় করা হয়েছে।',
    autosaving: 'এই ডকুমেন্টটি স্বয়ংক্রিয়ভাবে সংরক্ষণ করার সময় একটি সমস্যা হয়েছে।',
    correctInvalidFields: 'অবৈধ ক্ষেত্রগুলি সংশোধন করুন।',
    deletingFile: 'ফাইল মুছতে একটি ত্রুটি হয়েছে।',
    deletingTitle:
      '{{title}} মুছতে একটি ত্রুটি হয়েছে। আপনার সংযোগ পরীক্ষা করুন এবং আবার চেষ্টা করুন।',
    documentNotFound:
      'আইডি {{id}} এর সাথে সম্পর্কিত ডকুমেন্টটি পাওয়া যাচ্ছে না। এটি মোছা হয়েছে বা কখনই না থাকতে পারে, অথবা আপনার এর প্রবেশাধিকার না থ',
    emailOrPasswordIncorrect: 'প্রদত্ত ইমেইল বা পাসওয়ার্ড ভুল।',
    followingFieldsInvalid_one: 'নিম্নলিখিত ক্ষেত্রটি অবৈধ:',
    followingFieldsInvalid_other: 'নিম্নলিখিত ক্ষেত্রগুলি অবৈধ:',
    incorrectCollection: 'ভুল সংগ্রহ',
    insufficientClipboardPermissions:
      'ক্লিপবোর্ড অ্যাক্সেস প্রত্যাখ্যান করা হয়েছে। দয়া করে আপনার ক্লিপবোর্ড অনুমতিগুলি পরীক্ষা করুন।',
    invalidClipboardData: 'অবৈধ ক্লিপবোর্ড ডেটা।',
    invalidFileType: 'অবৈধ ফাইল প্রকার',
    invalidFileTypeValue: 'অবৈধ ফাইল প্রকার: {{value}}',
    invalidRequestArgs: 'অনুরোধে অবৈধ আর্গুমেন্ট পাস করা হয়েছে: {{args}}',
    loadingDocument: '{{id}} আইডি সহ ডকুমেন্ট লোড করতে একটি সমস্যা হয়েছে।',
    localesNotSaved_one: 'নিম্নলিখিত লোকেল সংরক্ষণ করা যায়নি:',
    localesNotSaved_other: 'নিম্নলিখিত লোকেলগুলি সংরক্ষণ করা যায়নি:',
    logoutFailed: 'লগআউট ব্যর্থ হয়েছে।',
    missingEmail: 'ইমেইল নেই।',
    missingIDOfDocument: 'আপডেট করার জন্য ডকুমেন্টের আইডি নেই।',
    missingIDOfVersion: 'সংস্করণের আইডি নেই।',
    missingRequiredData: 'প্রয়োজনীয় ডেটা নেই।',
    noFilesUploaded: 'কোনো ফাইল আপলোড করা হয়নি।',
    noMatchedField: '"{{label}}" এর জন্য কোনো মিল পাওয়া যায়নি',
    notAllowedToAccessPage: 'আপনি এই পৃষ্ঠাটি অ্যাক্সেস করার অনুমতি পাননি।',
    notAllowedToPerformAction: 'আপনি এই ক্রিয়া সম্পাদন করার অনুমতি পাননি।',
    notFound: 'অনুরোধ করা সম্পদ পাওয়া যায়নি।',
    noUser: 'কোনো ব্যবহারকারী নেই',
    previewing: 'এই ডকুমেন্টটি প্রিভিউ করতে একটি সমস্যা হয়েছে।',
    problemUploadingFile: 'ফাইল আপলোড করতে একটি সমস্যা হয়েছে।',
    restoringTitle:
      '{{title}} পুনরুদ্ধার করার সময় একটি ত্রুটি ঘটেছে। দয়া করে আপনার সংযোগ পরীক্ষা করুন এবং আবার চেষ্টা করুন।',
    tokenInvalidOrExpired: 'টোকেন অবৈধ বা মেয়াদ শেষ হয়ে গেছে।',
    tokenNotProvided: 'টোকেন প্রদান করা হয়নি।',
    unableToCopy: 'কপি করা সম্ভব নয়।',
    unableToDeleteCount: '{{total}} {{label}} এর মধ্যে {{count}} টি মুছতে অক্ষম।',
    unableToReindexCollection:
      '{{collection}} সংগ্রহ পুনরায় সূচিবদ্ধ করতে ত্রুটি হয়েছে। অপারেশন বাতিল করা হয়েছে।',
    unableToUpdateCount: '{{total}} {{label}} এর মধ্যে {{count}} টি আপডেট করতে অক্ষম।',
    unauthorized: 'অননুমোদিত, এই অনুরোধ করতে আপনাকে লগইন করতে হবে।',
    unauthorizedAdmin: 'অননুমোদিত, এই ব্যবহারকারীর অ্যাডমিন প্যানেলে অ্যাক্সেস নেই।',
    unknown: 'একটি অজানা ত্রুটি হয়েছে।',
    unPublishingDocument: 'এই ডকুমেন্টটি আনপাবলিশ করতে একটি সমস্যা হয়েছে।',
    unspecific: 'একটি ত্রুটি হয়েছে।',
    unverifiedEmail: 'লগইন করার আগে আপনার ইমেইল যাচাই করুন।',
    userEmailAlreadyRegistered: 'প্রদত্ত ইমেইল সহ একটি ব্যবহারকারী ইতিমধ্যে নিবন্ধিত হয়েছে।',
    userLocked: 'অনেকগুলি ব্যর্থ লগইন প্রচেষ্টার কারণে এই ব্যবহারকারী লক করা হয়েছে।',
    usernameAlreadyRegistered:
      'প্রদত্ত ব্যবহারকারীর নাম সহ একটি ব্যবহারকারী ইতিমধ্যে নিবন্ধিত হয়েছে।',
    usernameOrPasswordIncorrect: 'প্রদত্ত ব্যবহারকারীর নাম বা পাসওয়ার্ড ভুল।',
    valueMustBeUnique: 'মানটি অনন্য হতে হবে',
    verificationTokenInvalid: 'যাচাইকরণ টোকেন অবৈধ।',
  },
  fields: {
    addLabel: '{{label}} যোগ করুন',
    addLink: 'লিঙ্ক যোগ করুন',
    addNew: 'নতুন যোগ করুন',
    addNewLabel: 'নতুন {{label}} যোগ করুন',
    addRelationship: 'সম্পর্ক যোগ করুন',
    addUpload: 'আপলোড যোগ করুন',
    block: 'ব্লক',
    blocks: 'ব্লকগুলি',
    blockType: 'ব্লক প্রকার',
    chooseBetweenCustomTextOrDocument:
      'একটি কাস্টম টেক্সট URL লিখুন বা অন্য একটি ডকুমেন্টে লিঙ্ক করুন।',
    chooseDocumentToLink: 'লিঙ্ক করার জন্য একটি ডকুমেন্ট নির্বাচন করুন',
    chooseFromExisting: 'বিদ্যমান থেকে নির্বাচন করুন',
    chooseLabel: '{{label}} নির্বাচন করুন',
    collapseAll: 'সমস্ত সংকুচিত করুন',
    customURL: 'কাস্টম URL',
    editLabelData: '{{label}} ডেটা সম্পাদনা করুন',
    editLink: 'লিঙ্ক সম্পাদনা করুন',
    editRelationship: 'সম্পর্ক সম্পাদনা করুন',
    enterURL: 'একটি URL লিখুন',
    internalLink: 'অভ্যন্তরীণ লিঙ্ক',
    itemsAndMore: '{{items}} এবং {{count}} টি আরও',
    labelRelationship: '{{label}} সম্পর্ক',
    latitude: 'অক্ষাংশ',
    linkedTo: '<0>{{label}}</0> এর সাথে লিঙ্ক করা হয়েছে',
    linkType: 'লিঙ্ক প্রকার',
    longitude: 'দ্রাঘিমাংশ',
    newLabel: 'নতুন {{label}}',
    openInNewTab: 'নতুন ট্যাবে খুলুন',
    passwordsDoNotMatch: 'পাসওয়ার্ডগুলি মেলে না।',
    relatedDocument: 'সম্পর্কিত ডকুমেন্ট',
    relationTo: 'সম্পর্কিত',
    removeRelationship: 'সম্পর্ক সরান',
    removeUpload: 'আপলোড সরান',
    saveChanges: 'পরিবর্তনগুলি সংরক্ষণ করুন',
    searchForBlock: 'একটি ব্লক অনুসন্ধান করুন',
    searchForLanguage: 'একটি ভাষা অনুসন্ধান করুন',
    selectExistingLabel: 'বিদ্যমান {{label}} নির্বাচন করুন',
    selectFieldsToEdit: 'সম্পাদনা করার জন্য ক্ষেত্রগুলি নির্বাচন করুন',
    showAll: 'সমস্ত দেখান',
    swapRelationship: 'সম্পর্ক পরিবর্তন করুন',
    swapUpload: 'আপলোড পরিবর্তন করুন',
    textToDisplay: 'প্রদর্শিত টেক্সট',
    toggleBlock: 'ব্লক টগল করুন',
    uploadNewLabel: 'নতুন {{label}} আপলোড করুন',
  },
  folder: {
    browseByFolder: 'ফোল্ডার দ্বারা ব্রাউজ করুন',
    byFolder: 'ফোল্ডার দ্বারা',
    deleteFolder: 'ফোল্ডার মুছুন',
    folderName: 'ফোল্ডারের নাম',
    folders: 'ফোল্ডারগুলি',
    folderTypeDescription:
      'এই ফোল্ডারে কোন ধরনের সংগ্রহ নথিপত্র অনুমোদিত হওয়া উচিত তা নির্বাচন করুন।',
    itemHasBeenMoved: '{{title}} কে {{folderName}} এ সরানো হয়েছে',
    itemHasBeenMovedToRoot: '{{title}} কে মূল ফোল্ডারে সরানো হয়েছে',
    itemsMovedToFolder: '{{title}} কে {{folderName}} এ সরানো হয়েছে',
    itemsMovedToRoot: '{{title}} কে মূল ফোল্ডারে সরানো হয়েছে',
    moveFolder: 'ফোল্ডার সরান',
    moveItemsToFolderConfirmation:
      'আপনি <1>{{count}} {{label}}</1> কে <2>{{toFolder}}</2> এ সরাতে চলেছেন। আপনি কি নিশ্চিত?',
    moveItemsToRootConfirmation:
      'আপনি <1>{{count}} {{label}}</1> কে মূল ফোল্ডারে সরাতে চলেছেন। আপনি কি নিশ্চিত?',
    moveItemToFolderConfirmation:
      'আপনি <1>{{title}}</1> কে <2>{{toFolder}}</2> এ সরাতে চলেছেন। আপনি কি নিশ্চিত?',
    moveItemToRootConfirmation:
      'আপনি <1>{{title}}</1> কে মূল ফোল্ডারে সরাতে চলেছেন। আপনি কি নিশ্চিত?',
    movingFromFolder: '{{title}} কে {{fromFolder}} থেকে সরানো হচ্ছে',
    newFolder: 'নতুন ফোল্ডার',
    noFolder: 'কোনো ফোল্ডার নেই',
    renameFolder: 'ফোল্ডারের নাম পরিবর্তন করুন',
    searchByNameInFolder: '{{folderName}} এ নাম দ্বারা অনুসন্ধান করুন',
    selectFolderForItem: '{{title}} এর জন্য ফোল্ডার নির্বাচন করুন',
  },
  general: {
    name: 'নাম',
    aboutToDelete: 'আপনি {{label}} <1>{{title}}</1> মুছতে চলেছেন। আপনি কি নিশ্চিত?',
    aboutToDeleteCount_many: 'আপনি {{count}} {{label}} মুছতে চলেছেন',
    aboutToDeleteCount_one: 'আপনি {{count}} {{label}} মুছতে চলেছেন',
    aboutToDeleteCount_other: 'আপনি {{count}} {{label}} মুছতে চলেছেন',
    aboutToPermanentlyDelete:
      'আপনি স্থায়ীভাবে {{label}} <1>{{title}}</1> মুছে ফেলতে যাচ্ছেন। আপনি কি নিশ্চিত?',
    aboutToPermanentlyDeleteTrash:
      'আপনি চূর্ণনিবিন্ন <0>{{count}}</0> <1>{{label}}</1> টি সর্বদা মুছে ফেলতে যাচ্ছেন। আপনি কি নিশ্চিত?',
    aboutToRestore: 'আপনি কি নিশ্চিত যে আপনি {{label}} <1>{{title}}</1> পুনরুদ্ধার করতে চান?',
    aboutToRestoreAsDraft:
      'আপনি কি নিশ্চিত যে, আপনি {{label}} <1>{{title}}</1> একটি খসড়া হিসাবে পুনরুদ্ধার করতে চলেছেন?',
    aboutToRestoreAsDraftCount:
      'আপনি সম্প্রদায়ে {{count}} {{label}} খসড়া হিসাবে পুনরুদ্ধার করতে যাচ্ছেন',
    aboutToRestoreCount: 'আপনি এখন প্রস্তুত {{count}} {{label}} পুনরুদ্ধার করতে',
    aboutToTrash:
      'আপনি প্রথমরা {{label}} <1>{{title}}</1> কে আবর্জনায় স্থানান্তর করতে যাচ্ছেন। আপনি কি নিশ্চিত?',
    aboutToTrashCount: 'আপনি সম্পর্কে {{count}} {{label}} মুছে ফেলার জন্য সরিয়ে ফেলাতে যাচ্ছেন',
    addBelow: 'নিচে যোগ করুন',
    addFilter: 'ফিল্টার যোগ করুন',
    adminTheme: 'অ্যাডমিন থিম',
    all: 'সমস্ত',
    allCollections: 'সমস্ত সংগ্রহ',
    allLocales: 'সমস্ত লোকেল',
    and: 'এবং',
    anotherUser: 'অন্য ব্যবহারকারী',
    anotherUserTakenOver: 'অন্য একজন ব্যবহারকারী এই ডকুমেন্ট সম্পাদনার দায়িত্ব নিয়েছেন।',
    applyChanges: 'পরিবর্তনগুলি প্রয়োগ করুন',
    ascending: 'আরোহী',
    automatic: 'স্বয়ংক্রিয়',
    backToDashboard: 'ড্যাশবোর্ডে ফিরে যান',
    cancel: 'বাতিল করুন',
    changesNotSaved:
      'আপনার পরিবর্তনগুলি সংরক্ষণ করা হয়নি। আপনি যদি এখন চলে যান, তাহলে আপনার পরিবর্তনগুলি হারিয়ে যাবে।',
    clear:
      'মূল পাঠের অর্থ সম্মান করুন পেলোড প্রসঙ্গে। এখানে পেলোড নির্দিষ্ট বিশেষ অর্থ বহন করে এরকম একটি সাধারণ টার্মের তালিকা:\n    - সংগ্রহ',
    clearAll: 'সমস্ত সাফ করুন',
    close: 'বন্ধ করুন',
    collapse: 'সংকুচিত করুন',
    collections: 'সংগ্রহগুলি',
    columns: 'কলামগুলি',
    columnToSort: 'সাজানোর জন্য কলাম',
    confirm: 'নিশ্চিত করুন',
    confirmCopy: 'কপি নিশ্চিত করুন',
    confirmDeletion: 'মুছে ফেলা নিশ্চিত করুন',
    confirmDuplication: 'ডুপ্লিকেশন নিশ্চিত করুন',
    confirmMove: 'স্থানান্তর নিশ্চিত করুন',
    confirmReindex: 'সমস্ত {{collections}} পুনরায় সূচিবদ্ধ করবেন?',
    confirmReindexAll: 'সমস্ত সংগ্রহ পুনরায় সূচিবদ্ধ করবেন?',
    confirmReindexDescription:
      'এটি বিদ্যমান সূচিগুলি সরিয়ে দেবে এবং {{collections}} সংগ্রহগুলির ডকুমেন্টগুলি পুনরায় সূচিবদ্ধ করবে।',
    confirmReindexDescriptionAll:
      'এটি বিদ্যমান সূচিগুলি সরিয়ে দেবে এবং সমস্ত সংগ্রহগুলির ডকুমেন্টগুলি পুনরায় সূচিবদ্ধ করবে।',
    confirmRestoration: 'পুনরুদ্ধার নিশ্চিত করুন',
    copied: 'কপি করা হয়েছে',
    copy: 'কপি করুন',
    copyField: 'ফিল্ড কপি করুন',
    copying: 'কপি করা হচ্ছে',
    copyRow: 'সারি কপি করুন',
    copyWarning:
      'আপনি {{label}} {{title}} এর জন্য {{to}} কে {{from}} দ্বারা ওভাররাইট করতে চলেছেন। আপনি কি নিশ্চিত?',
    create: 'তৈরি করুন',
    created: 'তৈরি করা হয়েছে',
    createdAt: 'তৈরি করার তারিখ',
    createNew: 'নতুন তৈরি করুন',
    createNewLabel: 'নতুন {{label}} তৈরি করুন',
    creating: 'তৈরি করা হচ্ছে',
    creatingNewLabel: 'নতুন {{label}} তৈরি করা হচ্ছে',
    currentlyEditing:
      'বর্তমানে এই ডকুমেন্টটি সম্পাদনা করছেন। আপনি যদি দায়িত্ব নেন, তাহলে তারা সম্পাদনা করা থেকে ব্লক হয়ে যাবে এবং সংরক্ষণ না করা পরিবর্তনগুলি হারাতে পারে।',
    custom: 'কাস্টম',
    dark: 'ডার্ক',
    dashboard: 'ড্যাশবোর্ড',
    delete: 'মুছুন',
    deleted: 'মুছে ফেলা হয়েছে',
    deletedAt: 'মুছে ফেলার সময়',
    deletedCountSuccessfully: '{{count}} {{label}} সফলভাবে মুছে ফেলা হয়েছে।',
    deletedSuccessfully: 'সফলভাবে মুছে ফেলা হয়েছে।',
    deleteLabel: '{{label}} মুছে ফেলুন',
    deletePermanently: 'ট্র্যাশ এড়িয়ে স্থায়ীভাবে মুছুন',
    deleting: 'মুছে ফেলা হচ্ছে...',
    depth: 'গভীরতা',
    descending: 'অবরোহী',
    deselectAllRows: 'সমস্ত সারি নির্বাচন বাতিল করুন',
    document: 'ডকুমেন্ট',
    documentIsTrashed: 'এই {{label}} ট্র্যাশ করা হয়েছে এবং এটি শুধুমাত্র পাঠনীয়।',
    documentLocked: 'ডকুমেন্ট লক করা হয়েছে',
    documents: 'ডকুমেন্টগুলি',
    duplicate: 'ডুপ্লিকেট করুন',
    duplicateWithoutSaving: 'পরিবর্তনগুলি সংরক্ষণ না করে ডুপ্লিকেট করুন',
    edit: 'সম্পাদনা করুন',
    editAll: 'সমস্ত সম্পাদনা করুন',
    editedSince: 'থেকে সম্পাদিত হয়েছে',
    editing: 'সম্পাদনা করা হচ্ছে',
    editingLabel_many: '{{count}} {{label}} সম্পাদনা করা হচ্ছে',
    editingLabel_one: '{{count}} {{label}} সম্পাদনা করা হচ্ছে',
    editingLabel_other: '{{count}} {{label}} সম্পাদনা করা হচ্ছে',
    editingTakenOver: 'সম্পাদনার দায়িত্ব নেওয়া হয়েছে',
    editLabel: '{{label}} সম্পাদনা করুন',
    email: 'ইমেইল',
    emailAddress: 'ইমেইল ঠিকানা',
    emptyTrash: 'ট্র্যাশ খালি করুন',
    emptyTrashLabel: '{{label}} ট্র্যাশ খালি করুন',
    enterAValue: 'একটি মান লিখুন',
    error: 'ত্রুটি',
    errors: 'ত্রুটিগুলি',
    exitLivePreview: 'লাইভ প্রিভিউ প্রস্থান করুন',
    export: 'এক্সপোর্ট করুন',
    fallbackToDefaultLocale: 'ডিফল্ট লোকেলে ফিরে যান',
    false: 'মিথ্যা',
    filter: 'ফিল্টার করুন',
    filters: 'ফিল্টারগুলি',
    filterWhere: '{{label}} যেখানে ফিল্টার করুন',
    globals: 'গ্লোবালগুলি',
    goBack: 'পিছনে যান',
    groupByLabel: '{{label}} অনুযায়ী গ্রুপ করুন',
    import: 'ইম্পোর্ট করুন',
    isEditing: 'সম্পাদনা করছেন',
    item: 'আইটেম',
    items: 'আইটেমগুলি',
    language: 'ভাষা',
    lastModified: 'সর্বশেষ পরিবর্তিত',
    leaveAnyway: 'যাই হোক ছেড়ে দিন',
    leaveWithoutSaving: 'সংরক্ষণ না করে ছেড়ে দিন',
    light: 'লাইট',
    livePreview: 'লাইভ প্রিভিউ',
    loading: 'লোড হচ্ছে',
    locale: 'লোকেল',
    locales: 'লোকেলগুলি',
    lock: 'লক',
    menu: 'মেনু',
    moreOptions: 'আরও বিকল্পগুলি',
    move: 'স্থানান্তর করুন',
    moveConfirm:
      'আপনি {{count}} {{label}} কে <1>{{destination}}</1> এ স্থানান্তর করতে চলেছেন। আপনি কি নিশ্চিত?',
    moveCount: '{{count}} {{label}} স্থানান্তর করুন',
    moveDown: 'নিচে সরান',
    moveUp: 'উপরে সরান',
    moving: 'স্থানান্তর করা হচ্ছে',
    movingCount: '{{count}} {{label}} স্থানান্তর করা হচ্ছে',
    newLabel: 'নতুন {{label}}',
    newPassword: 'নতুন পাসওয়ার্ড',
    next: 'পরবর্তী',
    no: 'না',
    noDateSelected: 'কোনো তারিখ নির্বাচন করা হয়নি',
    noFiltersSet: 'কোনো ফিল্টার সেট করা হয়নি',
    noLabel: '<কোনো {{label}} নেই>',
    none: 'কোনোটিই নয়',
    noOptions: 'কোনো বিকল্প নেই',
    noResults:
      'কোনো {{label}} পাওয়া যায়নি। হয় এখনও কোনো {{label}} তৈরি করা হয়নি বা উপরে নির্দিষ্ট করা ফিল্টারগুলির সাথে কোনোটি মেলে না।',
    notFound: 'পাওয়া যায়নি',
    nothingFound: 'কিছুই পাওয়া যায়নি',
    noTrashResults: 'ট্র্যাশে কোন {{label}} নেই।',
    noUpcomingEventsScheduled: 'কোনো আসন্ন ইভেন্ট নির্ধারিত নেই।',
    noValue: 'কোনো মান নেই',
    of: 'এর',
    only: 'শুধুমাত্র',
    open: 'খুলুন',
    or: 'বা',
    order: 'অর্ডার',
    overwriteExistingData: 'বিদ্যমান ফিল্ড ডেটা ওভাররাইট করুন',
    pageNotFound: 'পৃষ্ঠা পাওয়া যায়নি',
    password: 'পাসওয়ার্ড',
    pasteField: 'ফিল্ড পেস্ট করুন',
    pasteRow: 'সারি পেস্ট করুন',
    payloadSettings: 'পেলোড সেটিংস',
    permanentlyDelete: 'চিরতরে মুছে ফেলুন',
    permanentlyDeletedCountSuccessfully:
      'স্থায়ীভাবে {{count}} {{label}} সফলভাবে মুছে ফেলা হয়েছে।',
    perPage: 'প্রতি পৃষ্ঠায়: {{limit}}',
    previous: 'পূর্ববর্তী',
    reindex: 'পুনরায় সূচিবদ্ধ করুন',
    reindexingAll: 'সমস্ত {{collections}} পুনরায় সূচিবদ্ধ করা হচ্ছে।',
    remove: 'অপসারণ করুন',
    rename: 'নাম পরিবর্তন করুন',
    reset: 'রিসেট করুন',
    resetPreferences: 'পছন্দগুলি রিসেট করুন',
    resetPreferencesDescription: 'এটি আপনার সমস্ত পছন্দগুলি তাদের ডিফল্ট সেটিংসে রিসেট করবে।',
    resettingPreferences: 'পছন্দগুলি রিসেট করা হচ্ছে।',
    restore: 'পুনরুদ্ধার করুন',
    restoreAsPublished: 'প্রকাশিত সংস্করণ হিসাবে পুনরুদ্ধার করুন',
    restoredCountSuccessfully: '{{count}} {{label}} সফলভাবে পুনরুদ্ধার করা হয়েছে।',
    restoring:
      'Payload এর প্রসঙ্গে মূল পাঠের অর্থ সম্মান করুন। এখানে Payload পদ গুলির একটি তালিকা রয়েছে যা খুব নির্দিষ্ট অর্থ বহন করে:\n     - সংগ্রহ: একটি সং',
    row: 'সারি',
    rows: 'সারিগুলি',
    save: 'সংরক্ষণ করুন',
    saving: 'সংরক্ষণ করা হচ্ছে...',
    schedulePublishFor: '{{title}} এর জন্য প্রকাশ নির্ধারণ করুন',
    searchBy: '{{label}} দ্বারা অনুসন্ধান করুন',
    select: 'নির্বাচন করুন',
    selectAll: 'সমস্ত {{count}} {{label}} নির্বাচন করুন',
    selectAllRows: 'সমস্ত সারি নির্বাচন করুন',
    selectedCount: '{{count}} {{label}} নির্বাচিত হয়েছে',
    selectLabel: '{{label}} নির্বাচন করুন',
    selectValue: 'একটি মান নির্বাচন করুন',
    showAllLabel: 'সমস্ত {{label}} দেখান',
    sorryNotFound: 'দুঃখিত—আপনার অনুরোধের সাথে মিলে এমন কিছুই নেই।',
    sort: 'সাজান',
    sortByLabelDirection: '{{label}} দ্বারা {{direction}} সাজান',
    stayOnThisPage: 'এই পৃষ্ঠায় থাকুন',
    submissionSuccessful: 'জমা সফল হয়েছে।',
    submit: 'জমা দিন',
    submitting: 'জমা দেওয়া হচ্ছে...',
    success: 'সাফল্য',
    successfullyCreated: '{{label}} সফলভাবে তৈরি করা হয়েছে।',
    successfullyDuplicated: '{{label}} সফলভাবে ডুপ্লিকেট করা হয়েছে।',
    successfullyReindexed:
      '{{collections}} থেকে মোট {{total}}টি ডকুমেন্টের মধ্যে {{count}}টি সফলভাবে পুনরায় ইনডেক্স করা হয়েছে এবং {{skips}}টি খসড়া বাদ দেওয়া হয়েছে।',
    takeOver: 'দায়িত্ব নিন',
    thisLanguage: 'বাংলা (বাংলাদেশ)',
    time: 'সময়',
    timezone: 'টাইমজোন',
    titleDeleted: '{{label}} "{{title}}" সফলভাবে মুছে ফেলা হয়েছে।',
    titleRestored: '"{{label}}" "{{title}}" সফলভাবে পুনরুদ্ধার করা হয়েছে।',
    titleTrashed: '{{label}} "{{title}}" আবর্জনাস্থলে সরিয়ে নেওয়া হয়েছে।',
    trash: 'আবর্জনা',
    trashedCountSuccessfully: '{{count}} {{label}} ট্র্যাশে মুভ করা হয়েছে।',
    true: 'সত্য',
    unauthorized: 'অননুমোদিত',
    unlock: 'আনলক করুন',
    unsavedChanges:
      'আপনার কাছে সংরক্ষণ না করা পরিবর্তনগুলি রয়েছে। চালিয়ে যাওয়ার আগে সংরক্ষণ করুন বা বাতিল করুন।',
    unsavedChangesDuplicate:
      'আপনার কাছে সংরক্ষণ না করা পরিবর্তনগুলি রয়েছে। আপনি কি ডুপ্লিকেট করতে চালিয়ে যেতে চান?',
    untitled: 'শিরোনামহীন',
    upcomingEvents: 'আসন্ন ইভেন্টগুলি',
    updatedAt: 'আপডেট করা হয়েছে',
    updatedCountSuccessfully: '{{count}} {{label}} সফলভাবে আপডেট করা হয়েছে।',
    updatedLabelSuccessfully: '{{label}} সফলভাবে আপডেট করা হয়েছে।',
    updatedSuccessfully: 'সফলভাবে আপডেট করা হয়েছে।',
    updateForEveryone: 'সবার জন্য আপডেট করুন',
    updating: 'আপডেট করা হচ্ছে',
    uploading: 'আপলোড করা হচ্ছে',
    uploadingBulk: '{{total}} এর মধ্যে {{current}} আপলোড করা হচ্ছে',
    user: 'ব্যবহারকারী',
    username: 'ব্যবহারকারীর নাম',
    users: 'ব্যবহারকারীরা',
    value: 'মান',
    viewing: 'দেখা',
    viewReadOnly: 'শুধুমাত্র পড়ার জন্য দেখুন',
    welcome: 'স্বাগতম',
    yes: 'হ্যাঁ',
  },
  localization: {
    cannotCopySameLocale: 'একই লোকেলে কপি করা যাবে না',
    copyFrom: 'থেকে কপি করুন',
    copyFromTo: '{{from}} থেকে {{to}} তে কপি করা হচ্ছে',
    copyTo: 'কপি করুন',
    copyToLocale: 'লোকেলে কপি করুন',
    localeToPublish: 'প্রকাশ করার লোকেল',
    selectedLocales: 'নির্বাচিত ভাষা অথবা এলাকা',
    selectLocaleToCopy: 'কপি করার জন্য লোকেল নির্বাচন করুন',
    selectLocaleToDuplicate: 'নির্বাচনকৃত লোকেলগুলি প্রতিলিপি করুন',
  },
  operators: {
    contains: 'ধারণ করে',
    equals: 'সমান',
    exists: 'বিদ্যমান',
    intersects: 'ছেদ করে',
    isGreaterThan: 'এর চেয়ে বড়',
    isGreaterThanOrEqualTo: 'এর চেয়ে বড় বা সমান',
    isIn: 'এর মধ্যে রয়েছে',
    isLessThan: 'এর চেয়ে ছোট',
    isLessThanOrEqualTo: 'এর চেয়ে ছোট বা সমান',
    isLike: 'এর মতো',
    isNotEqualTo: 'এর সমান নয়',
    isNotIn: 'এর মধ্যে নেই',
    isNotLike: 'এর মতো নয়',
    near: 'কাছে',
    within: 'এর মধ্যে',
  },
  upload: {
    addFile: 'ফাইল যোগ করুন',
    addFiles: 'ফাইলগুলি যোগ করুন',
    bulkUpload: 'বাল্ক আপলোড',
    crop: 'ক্রপ করুন',
    cropToolDescription:
      'নির্বাচিত অঞ্চলের কোণগুলি টানুন, একটি নতুন অঞ্চল আঁকুন বা নিচের মানগুলি সামঞ্জস্য করুন।',
    download: 'ডাউনলোড করুন',
    dragAndDrop: 'একটি ফাইল টেনে এনে ছেড়ে দিন',
    dragAndDropHere: 'অথবা একটি ফাইল টেনে এনে এখানে ছেড়ে দিন',
    editImage: 'ছবি সম্পাদনা করুন',
    fileName: 'ফাইলের নাম',
    fileSize: 'ফাইলের আকার',
    filesToUpload: 'আপলোড করার ফাইলগুলি',
    fileToUpload: 'আপলোড করার ফাইল',
    focalPoint: 'ফোকাল পয়েন্ট',
    focalPointDescription: 'প্রিভিউতে সরাসরি ফোকাল পয়েন্ট টানুন বা নিচের মানগুলি সামঞ্জস্য করুন।',
    height: 'উচ্চতা',
    lessInfo: 'কম তথ্য',
    moreInfo: 'আরও তথ্য',
    noFile: 'কোনো ফাইল নেই',
    pasteURL: 'URL পেস্ট করুন',
    previewSizes: 'প্রিভিউ আকারগুলি',
    selectCollectionToBrowse: 'ব্রাউজ করার জন্য একটি সংগ্রহ নির্বাচন করুন',
    selectFile: 'একটি ফাইল নির্বাচন করুন',
    setCropArea: 'ক্রপ অঞ্চল সেট করুন',
    setFocalPoint: 'ফোকাল পয়েন্ট সেট করুন',
    sizes: 'আকারগুলি',
    sizesFor: '{{label}} এর জন্য আকারগুলি',
    width: 'প্রস্থ',
  },
  validation: {
    emailAddress: 'একটি বৈধ ইমেইল ঠিকানা লিখুন।',
    enterNumber: 'একটি বৈধ সংখ্যা লিখুন।',
    fieldHasNo: 'এই ক্ষেত্রে কোনো {{label}} নেই',
    greaterThanMax: '{{value}} সর্বাধিক অনুমোদিত {{label}} {{max}} এর চেয়ে বড়।',
    invalidBlock: 'ব্লক "{{block}}" অনুমোদিত নয়।',
    invalidBlocks: 'এই ক্ষেত্রটি আর অনুমোদিত না থাকা ব্লকগুলি ধারণ করে: {{blocks}}।',
    invalidInput: 'এই ক্ষেত্রে একটি অবৈধ ইনপুট রয়েছে।',
    invalidSelection: 'এই ক্ষেত্রে একটি অবৈধ নির্বাচন রয়েছে।',
    invalidSelections: 'এই ক্ষেত্রে নিম্নলিখিত অবৈধ নির্বাচনগুলি রয়েছে:',
    latitudeOutOfBounds: 'অক্ষাংশ -90 এবং 90 এর মধ্যে হতে হবে।',
    lessThanMin: '{{value}} সর্বনিম্ন অনুমোদিত {{label}} {{min}} এর চেয়ে ছোট।',
    limitReached: 'সীমা reached, সর্বাধিক {{max}} আইটেম যোগ করা যাবে।',
    longerThanMin: 'এই মানটি সর্বনিম্ন {{minLength}} অক্ষরের চেয়ে লম্বা হতে হবে।',
    longitudeOutOfBounds: 'দ্রাগিমাংস অবশ্যই -১৮০ এবং ১৮০ এর মধ্যে হতে হবে।',
    notValidDate: '"{{value}}" একটি বৈধ তারিখ নয়।',
    required: 'এই ক্ষেত্রটি প্রয়োজনীয়।',
    requiresAtLeast: 'এই ক্ষেত্রটির জন্য কমপক্ষে {{count}} {{label}} প্রয়োজন।',
    requiresNoMoreThan: 'এই ক্ষেত্রটির জন্য {{count}} {{label}} এর বেশি প্রয়োজন নেই।',
    requiresTwoNumbers: 'এই ক্ষেত্রটির জন্য দুটি সংখ্যা প্রয়োজন।',
    shorterThanMax: 'এই মানটি সর্বাধিক {{maxLength}} অক্ষরের চেয়ে ছোট হতে হবে।',
    timezoneRequired: 'একটি টাইমজোন প্রয়োজন।',
    trueOrFalse: 'এই ক্ষেত্রটি শুধুমাত্র সত্য বা মিথ্যা হতে পারে।',
    username:
      'একটি বৈধ ব্যবহারকারীর নাম লিখুন। এতে অক্ষর, সংখ্যা, হাইফেন, পিরিয়ড এবং আন্ডারস্কোর থাকতে পারে।',
    validUploadID: 'এই ক্ষেত্রটি একটি বৈধ আপলোড আইডি নয়।',
  },
  version: {
    type: 'প্রকার',
    aboutToPublishSelection: 'আপনি নির্বাচনে সমস্ত {{label}} প্রকাশ করতে চলেছেন। আপনি কি নিশ্চিত?',
    aboutToRestore:
      'আপনি এই {{label}} ডকুমেন্টটি {{versionDate}} তারিখে যে অবস্থায় ছিল সেই অবস্থায় পুনরুদ্ধার করতে চলেছেন।',
    aboutToRestoreGlobal:
      'আপনি গ্লোবাল {{label}} কে {{versionDate}} তারিখে যে অবস্থায় ছিল সেই অবস্থায় পুনরুদ্ধার করতে চলেছেন।',
    aboutToRevertToPublished:
      'আপনি এই ডকুমেন্টের পরিবর্তনগুলি তার প্রকাশিত অবস্থায় ফিরিয়ে আনতে চলেছেন। আপনি কি নিশ্চিত?',
    aboutToUnpublish: 'আপনি এই ডকুমেন্টটি আনপাবলিশ করতে চলেছেন। আপনি কি নিশ্চিত?',
    aboutToUnpublishSelection:
      'আপনি নির্বাচনে সমস্ত {{label}} আনপাবলিশ করতে চলেছেন। আপনি কি নিশ্চিত?',
    autosave: 'স্বয়ংক্রিয় সংরক্ষণ',
    autosavedSuccessfully: 'স্বয়ংক্রিয়ভাবে সংরক্ষণ করা হয়েছে।',
    autosavedVersion: 'স্বয়ংক্রিয়ভাবে সংরক্ষণ করা সংস্করণ',
    changed: 'পরিবর্তিত হয়েছে',
    changedFieldsCount_one: '{{count}} পরিবর্তিত ক্ষেত্র',
    changedFieldsCount_other: '{{count}} পরিবর্তিত ক্ষেত্রগুলি',
    compareVersion: 'সংস্করণের সাথে তুলনা করুন:',
    compareVersions: 'সংস্করণ তুলনা করুন',
    comparingAgainst: 'তুলনা করা যাচ্ছে',
    confirmPublish: 'প্রকাশ নিশ্চিত করুন',
    confirmRevertToSaved: 'সংরক্ষিত অবস্থায় ফিরে যাওয়া নিশ্চিত করুন',
    confirmUnpublish: 'আনপাবলিশ নিশ্চিত করুন',
    confirmVersionRestoration: 'সংস্করণ পুনরুদ্ধার নিশ্চিত করুন',
    currentDocumentStatus: 'বর্তমান {{docStatus}} ডকুমেন্ট',
    currentDraft: 'বর্তমান খসড়া',
    currentlyPublished: 'বর্তমানে প্রকাশিত',
    currentlyViewing: 'বর্তমানে দেখছেন',
    currentPublishedVersion: 'বর্তমান প্রকাশিত সংস্করণ',
    draft: 'খসড়া',
    draftHasPublishedVersion: 'খসড়া (প্রকাশিত সংস্করণ রয়েছে)',
    draftSavedSuccessfully: 'খসড়া সফলভাবে সংরক্ষিত হয়েছে।',
    lastSavedAgo: 'সর্বশেষ সংরক্ষণ করা হয়েছে {{distance}} আগে',
    modifiedOnly: 'শুধুমাত্র পরিবর্তিত',
    moreVersions: 'আরও সংস্করণ...',
    noFurtherVersionsFound: 'আর কোনো সংস্করণ পাওয়া যায়নি',
    noLabelGroup:
      'মূল বাক্যের অর্থ প্রেিত্ষ্যে সম্মান রাখুন। নিম্নে পেলোডের কিছু সাধারণ শর্তাবলীর তালিকা প্রদান করেছে যা খুব নির্দিষ্ট অর্থ বহন করে:',
    noRowsFound: 'কোনো {{label}} পাওয়া যায়নি',
    noRowsSelected: 'কোনো {{label}} নির্বাচিত হয়নি',
    preview: 'প্রাকদর্শন',
    previouslyDraft: 'পূর্বে একটি খসড়া',
    previouslyPublished: 'পূর্বে প্রকাশিত',
    previousVersion: 'পূর্ববর্তী সংস্করণ',
    problemRestoringVersion: 'এই সংস্করণ পুনরুদ্ধারে সমস্যা হয়েছে',
    publish: 'প্রকাশ করুন',
    publishAllLocales: 'সমস্ত লোকেল প্রকাশ করুন',
    publishChanges: 'পরিবর্তনসমূহ প্রকাশ করুন',
    published: 'প্রকাশিত',
    publishIn: '{{locale}}-এ প্রকাশ করুন',
    publishing: 'প্রকাশ করা হচ্ছে',
    restoreAsDraft: 'খসড়া হিসেবে পুনরুদ্ধার করুন',
    restoredSuccessfully: 'সফলভাবে পুনরুদ্ধার করা হয়েছে।',
    restoreThisVersion: 'এই সংস্করণ পুনরুদ্ধার করুন',
    restoring: 'পুনরুদ্ধার করা হচ্ছে...',
    reverting: 'পূর্বাবস্থায় ফেরানো হচ্ছে...',
    revertToPublished: 'প্রকাশিত সংস্করণে ফিরে যান',
    saveDraft: 'খসড়া সংরক্ষণ করুন',
    scheduledSuccessfully: 'সফলভাবে নির্ধারিত হয়েছে।',
    schedulePublish: 'প্রকাশের সময়সূচী নির্ধারণ করুন',
    selectLocales: 'প্রদর্শনের জন্য লোকেল নির্বাচন করুন',
    selectVersionToCompare: 'তুলনার জন্য একটি সংস্করণ নির্বাচন করুন',
    showingVersionsFor: 'এর জন্য সংস্করণগুলি দেখানো হচ্ছে:',
    showLocales: 'লোকেল দেখান:',
    specificVersion: 'নির্দিষ্ট সংস্করণ',
    status: 'স্থিতি',
    unpublish: 'প্রকাশ বাতিল করুন',
    unpublishing: 'প্রকাশ বাতিল করা হচ্ছে...',
    version: 'সংস্করণ',
    versionAgo: '{{distance}} পূর্বে',
    versionCount_many: '{{count}}টি সংস্করণ পাওয়া গেছে',
    versionCount_none: 'কোনো সংস্করণ পাওয়া যায়নি',
    versionCount_one: '{{count}}টি সংস্করণ পাওয়া গেছে',
    versionCount_other: '{{count}}টি সংস্করণ পাওয়া গেছে',
    versionID: 'সংস্করণ আইডি',
    versions: 'সংস্করণসমূহ',
    viewingVersion: '{{entityLabel}} {{documentTitle}}-এর সংস্করণ দেখানো হচ্ছে',
    viewingVersionGlobal: 'গ্লোবাল {{entityLabel}}-এর সংস্করণ দেখানো হচ্ছে',
    viewingVersions: '{{entityLabel}} {{documentTitle}}-এর সংস্করণসমূহ দেখানো হচ্ছে',
    viewingVersionsGlobal: 'গ্লোবাল {{entityLabel}}-এর সংস্করণসমূহ দেখানো হচ্ছে',
  },
}

export const bnBd: Language = {
  dateFNSKey: 'bn-BD',
  translations: bnBdTranslations,
}
